// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2cIiJ","error":"Textarea_error__1XTSb","readonly":"Textarea_readonly__3ToSr","disabled":"Textarea_disabled__1j47n"};